import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { withTheme } from 'styled-components';
import { withRouteData, Switch, Route } from 'react-static';
import { SingleColumnLayout, SingleColumnLayoutContentWrapper, SingleColumnLayoutHeader } from '@flow/components/ui';
import { IPage } from 'types/IPage';
import { IArtist } from 'types/IArtist';
import { IArtists } from 'types/IArtists';
import * as NavigationAction from '@flow/store/navigation/actions';
import { connect } from 'react-redux';
import Artist from '@flow/scenes/artist/Artist';
import SEOTags from '@flow/components/seo/SEOTags';
import { renderDays } from '@flow/scenes/artists/ui';
import moment from 'moment';
import { isTagInArray } from '@flow/utils/helperUtils';
import { TagList } from '@flow/components/tags/tags';
import { MUSIC_PROGRAM_COMPLETED, PROGRAM_PAGE_NAVIGATION_ENABLED } from '@flow/utils/constants';
import { ProgramNavigation } from '@flow/components/navigation/ProgramNavigation';
import { renderContent } from '@flow/scenes/default/ui';

const ArtistListIncompleteMessage = styled.span`
  display: inline-block;
  font-family: Flow-Poster-Bold;
  font-size: 2.8em;
  text-transform: uppercase;
  text-align: center;
`;

const ArtistListIncompleteMessageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 0.2em solid ${props => props.theme.highlightColor};
  border-bottom: 0.2em solid ${props => props.theme.highlightColor};
  box-sizing: border-box;
  margin-bottom: 10em;
  color: ${props => props.theme.highlightColor};
  padding: 2.4em;
  
  @media (max-width: 700px) {
    ${ArtistListIncompleteMessage} {
      .dingbats {
        display: none;
      }  
    }
  }
  
  @media (max-width: 520px) {
    font-size: 80%;
  }
`;


interface Props {
  appLanguage: IAppLanguage;
  artists: IArtists;
  slugBases: any;
  page: IPage;
  _setLanguage: any;
  match: any;
  programPageNavigation: ProgramPageNavigation;
  theme: {isMobile: boolean};
}

interface State {
  tags: string[];
}

class Artists extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      tags: []
    };
  }

  componentWillMount() {
    const {
      appLanguage,
      _setLanguage,
      page,
    } = this.props;

    const lang_versions = page && page.lang_versions;

    _setLanguage({ appLanguage, lang_versions});
  }

  componentWillReceiveProps({
    appLanguage,
    page,
  }: Props) {
    const {
      _setLanguage,
    } = this.props;

    const lang_versions = page && page.lang_versions;

    _setLanguage({ appLanguage, lang_versions });
  }

  // TODO: This is a horrible hack, redo this when you have time to do it
  private _getVisibleArtists = (appLanguage: IAppLanguage, artists: IArtists[], filters: {tags: string[]}): IArtists => {
    const dayTags = appLanguage.code === 'fi' ? ['perjantai', 'lauantai', 'sunnuntai'] : ['Friday', 'Saturday', 'Sunday'];
    let visibleList: IArtist[] = [...artists];

    const dayFilters = filters.tags.filter(tag => dayTags.includes(tag))
    if (dayFilters.length) {
      visibleList = visibleList.filter(item => item.tags.some(tag => dayFilters.includes(tag.name)));
    }

    if (filters.tags.length > dayFilters.length) {
      let filterKeys = Object.keys(filters);
      visibleList = visibleList.filter((artist: IArtist) => {
        return filterKeys.every(key => {
          if (!filters[key].length) {
            return artists;
          }

          if (artist[key].length === 0)
            return false;

          return artist[key].find(tag => {
            const notDayFilters = filters[key].filter(tag => dayFilters.indexOf(tag) === -1)
            return notDayFilters.includes(tag.name)
          });
        });
      });
    }
    return visibleList;
  };

  render() {
    const {
      appLanguage,
      artists,
      page,
      theme: {
        isMobile
      },
      match: {
        url
      },
      programPageNavigation
    } = this.props;

    let content_group: any = page ? page.content_group : undefined;

    let uniqueTags: {name: string, order: number}[] = [];
    let visibleArtists: IArtist[] = [];
    if (artists) {
      artists.map((artist: IArtist) => {
        /*
         * add event date tag for every artists
         */
        let date: moment.Moment = moment(artist.event.date);
        if (date.isValid()) {
          let dayTag: {name: string} = {name: date.locale(appLanguage.code).format('dddd')};
          if (!artist.tags.find(tag => tag.name === dayTag.name)) {
            artist.tags.push(dayTag);
          }
        }

        /*
         * Generate unique tags for tag menu
         */
        const _getOrderIndex = (tag: string): number => {
          let index: number;
          switch (tag) {
            case 'perjantai':
            case 'Friday':
              index = 0;
              break;

            case 'lauantai':
            case 'Saturday':
              index = 1;
              break;

            case 'sunnuntai':
            case 'Sunday':
              index = 2;
              break;

            default:
              index = 3;
          }
          return index;
        };

        artist.tags.map((tag: {name: string}) => {
          if (!isTagInArray(tag, uniqueTags)) {
            uniqueTags.push({
              name: tag.name,
              order: _getOrderIndex(tag.name)
            });
          }
        });
      });

      if (uniqueTags.length > 0) {
        uniqueTags.sort((a: {order: number}, b: {order: number}) => {
          return a.order - b.order;
        });
      }

      visibleArtists = this._getVisibleArtists(
          appLanguage,
        artists,
        {tags: this.state.tags}
      );
    }

    return (
      <Switch>
        <Route
          path={url}
          exact
          render={() => (
            <SingleColumnLayout>
              <SEOTags page={page} />
              <SingleColumnLayoutHeader>
                {PROGRAM_PAGE_NAVIGATION_ENABLED ? (
                  <ProgramNavigation programPageNavigation={programPageNavigation} />
                ) : (
                  <h2>{page.title}</h2>
                )}
              </SingleColumnLayoutHeader>

              {Boolean(content_group) &&
              <SingleColumnLayoutContentWrapper>
                { renderContent(content_group) }
              </SingleColumnLayoutContentWrapper>
              }

              {uniqueTags && uniqueTags.length > 0 &&
                <TagList tagsUpdated={(tags: string[]) => this.setState({tags})} tags={uniqueTags} />
              }
              {renderDays(visibleArtists, appLanguage, isMobile)}

              {Boolean(artists && artists.length > 0 && !MUSIC_PROGRAM_COMPLETED && (
                <ArtistListIncompleteMessageWrapper>
                  <ArtistListIncompleteMessage><span className='dingbats'>⟚</span> <FormattedMessage id={'artists.artistListInCompleted'}/><span className='dingbats'>❂✧</span></ArtistListIncompleteMessage>
                </ArtistListIncompleteMessageWrapper>
              ))}
            </SingleColumnLayout>
        )}
        >
        </Route>
        <Route path={`${url}/:artistID/`} component={Artist} />
      </Switch>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withRouteData(withTheme(Artists)));



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/artists/Artists.tsx